(function () {
  'use strict';
  var root = document.getElementById('zv3-root');
  var index = document.getElementById('zv35-product-index');
  if (!root || !index || !index.content) return;
  var login = document.getElementById('zv41-storefront-login');
  var language = (root.getAttribute('data-locale') || 'en').slice(0, 2).toLowerCase();
  var loginLabels = {da: 'Log ind på webshoppen', fr: 'Se connecter à la boutique',
    it: 'Accedi al negozio', es: 'Iniciar sesión en la tienda', nl: 'Inloggen bij de webshop',
    de: 'Im Shop anmelden', fi: 'Kirjaudu verkkokauppaan', en: 'Sign in to the store'};
  if (login && login.querySelector('span')) login.querySelector('span').textContent = loginLabels[language] || loginLabels.en;
  var products = Object.create(null);
  index.content.querySelectorAll('[data-handle]').forEach(function (item) {
    var variants = [];
    item.querySelectorAll('[data-variant-id]').forEach(function (variant) {
      variants.push(variant.getAttribute('data-variant-id'));
    });
    products[item.getAttribute('data-handle')] = {
      url: item.getAttribute('data-url'),
      variants: variants
    };
  });
  var hosts = ['dk.zaltify.com', 'fr.zaltify.com', 'it.zaltify.com', 'es.zaltify.com',
    'nl.zaltify.com', 'de.zaltify.com', 'fi.zaltify.com', 'eu.zaltify.com', 'cvadhx-sd.myshopify.com'];
  function prepareLink(event) {
    var target = event.target;
    var link = target && target.closest && target.closest('a[href]');
    if (!link || !link.closest('.kl-hub-route-chat')) return;
    var url;
    try { url = new URL(link.getAttribute('href'), location.origin); } catch (error) { return; }
    if (url.protocol !== 'https:' || hosts.indexOf(url.hostname) === -1) return;
    var match = url.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/([^/]+)\/?$/i);
    var product = match && products[match[1]];
    if (!product) return;
    var variant = url.searchParams.get('variant');
    if (variant && product.variants.indexOf(variant) === -1) return;
    var local;
    try { local = new URL(product.url, location.origin); } catch (error) { return; }
    if (local.origin !== location.origin) return;
    local.search = url.search;
    local.hash = url.hash;
    local.searchParams.set('utm_source', 'customer_agent');
    local.searchParams.set('utm_medium', 'chat');
    local.searchParams.set('utm_campaign', 'zaltify_glasraadgiver');
    var content = local.searchParams.get('utm_content');
    if (!content) local.searchParams.set('utm_content', 'product_' + match[1].replace(/^zalto-/, '').replace(/-glass$/, '') + (variant ? '_variant_' + variant : ''));
    var value = local.toString();
    if (link.getAttribute('href') !== value) link.setAttribute('href', value);
  }
  ['pointerover', 'pointerdown', 'focusin', 'click'].forEach(function (name) {
    document.addEventListener(name, prepareLink, true);
  });
  // Disabled experimental conversation-context injection.
  // Concurrent background-context submission could race with sendChatMessage.
  // Market context remains available in Shopify Liquid product/variant data and links.
})();
